export enum Currency {
    Ron = 'ron'
}
